/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Col, Divider, Row, Spin } from 'antd'
import { useIndex } from 'app/lib/hooks/useApi'
import { FilterType } from 'app/redux/actions/typing'
import React, { useEffect } from 'react'

import { RecordType } from '../../../constants/GlobalTypes'
import CategoryListItem from './ListItem'

type Props = {
  filters?: FilterType
  onCategoryClick?: (categorySegment: ICategory) => void
}

const CategoryParentList: React.FC<Props> = ({ onCategoryClick, filters }) => {
  const {
    loading,
    execute,
    response: { data }
  } = useIndex<ICategoryParent>(RecordType.category)

  useEffect(() => {
    execute({ ...filters })
  }, [JSON.stringify(filters)])

  const renderChildCategories = (category: ICategory) => (
    <CategoryListItem
      key={category.id}
      member={category}
      props={{ onClick: () => onCategoryClick(category) }}
    />
  )

  return (
    <Spin spinning={loading} className="mt-3">
      <Row gutter={[0, 24]}>
        {data.map((item, index) => {
          const childCategories = item.child_categories.filter(
            (item) => item.category_segments.length
          )

          return (
            <React.Fragment key={`${item.parent.id}-${index}`}>
              <If condition={childCategories.length}>
                <Col span={24}>
                  <Row gutter={[0, 12]}>
                    <Col span={24} className="text-muted">
                      {item.parent.name}
                    </Col>
                    <Col span={24}>{childCategories.map(renderChildCategories)}</Col>
                  </Row>
                  <Divider className="my-0" />
                </Col>
              </If>
            </React.Fragment>
          )
        })}
      </Row>
    </Spin>
  )
}

export default CategoryParentList
